/* Add new feature flags here.
 * This constant should always reflect the current state of created feature flags,
 * switches and samples in the database.
 *
 * The keys are the plain text flag names as they appear in the Feature Flags API.
 * For example: "my_feature_flag" -> "myFeatureFlag"
 */

export enum Flag {
  // test values for Jest and Storybook tests (not in DB)
  TestFlag = "testFlag",
  TestFlag2 = "testFlag2",
  TestStaffOnlyFlag = "testStaffOnlyFlag",

  QuickSiteJump = "quickSiteJump",
  blockRueckerstattungP6Eeg = "blockRueckerstattungP6Eeg",
  LaikaPilot = "laikaPilot",
  ShowErzeugerExpress = "showErzeugerExpress",
  showErzeugerExpressVollmachten = "showErzeugerExpressVollmachten"
}

export type FeatureFlags = Record<Flag, boolean>;

export interface FeatureFlagsResponse {
  flags: FeatureFlags;
  /** Flags enabled for staff only. They are only active while the staff view is shown. */
  enabledForStaffOnly: Array<Flag>;
}
